"use client";

import { CallBlock } from "./CallBlock";
import { MessageBlock } from "./MessageBlock";
import { EmailBlock } from "./EmailBlock";
import { SystemBlock } from "./SystemBlock";
import { StatusChangeBlock } from "./StatusChangeBlock";
import { NoteBlock } from "./NoteBlock";

interface TimelineEntryProps {
  entry: {
    id: string;
    entryType: string;
    subject: string | null;
    body: string | null;
    metadata: Record<string, unknown> | null;
    userName: string | null;
    status: string;
    createdAt: string;
  };
}

export function TimelineEntry({ entry }: TimelineEntryProps) {
  switch (entry.entryType) {
    case "call_outbound":
    case "call_inbound":
      return (
        <CallBlock
          entryType={entry.entryType}
          metadata={entry.metadata}
          body={entry.body}
          createdAt={entry.createdAt}
          userName={entry.userName}
        />
      );
    case "sms_sent":
    case "sms_received":
    case "whatsapp_sent":
    case "whatsapp_received":
      return (
        <MessageBlock
          entryType={entry.entryType}
          body={entry.body}
          status={entry.status}
          createdAt={entry.createdAt}
          userName={entry.userName}
        />
      );
    case "email_sent":
    case "email_received":
      return (
        <EmailBlock
          entryType={entry.entryType}
          subject={entry.subject}
          body={entry.body}
          status={entry.status}
          createdAt={entry.createdAt}
          userName={entry.userName}
        />
      );
    case "system_notification":
      return <SystemBlock body={entry.body} createdAt={entry.createdAt} />;
    case "status_change":
      return <StatusChangeBlock body={entry.body} metadata={entry.metadata} createdAt={entry.createdAt} />;
    case "note":
      return <NoteBlock body={entry.body} createdAt={entry.createdAt} userName={entry.userName} />;
    default:
      return (
        <div className="rounded-lg border border-gray-100 bg-gray-50 p-3 text-xs text-gray-500">
          Unknown entry type: {entry.entryType}
        </div>
      );
  }
}
